import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudService } from 'environments/crud.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../environments/environment'
import Swal from 'sweetalert2';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-ejecuciones',
  templateUrl: './ejecuciones.component.html',
  styleUrls: ['./ejecuciones.component.css'],
  providers: [ CrudService ]
})
export class EjecucionesComponent implements OnInit {
  nombre = ''
  evaluacion = {
    id:'',
    evaluacion:'',
    cedis:'',
    evaluador:'',
    cliente:{nombre:'', numero:''},
    fecha_de_ejecucion:'',
    ie:'',
    ofv:'',
    av:'',
  }
  token  = sessionStorage.getItem('token')
  categorias = []
  evidencia = ""
  url = environment.apiUrl.substring(0, environment.apiUrl.length-1);
  public modalRef: BsModalRef;

  constructor(
    private crud: CrudService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.crud.getData('sensos/'+params.id, this.token, {}).subscribe(
        response => {
          console.log("response", response);
          this.evaluacion = response.data
          this.categorias = response.categorias
          console.log("categorias", this.categorias);

        },
        error => {
  
        }
      )

    })
  }

  onSubmit(){}

  openModal(template: TemplateRef<any>, imagen) {
    console.log("imagen", imagen);
    this.evidencia = imagen;
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
  }

  reporteExcel(seccion){
    Swal.fire({
      title: 'Cargando datos',
      onBeforeOpen () {
        Swal.showLoading ()
      },
      onAfterClose () {
        Swal.hideLoading()
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton:false
    })
    this.crud.exportExcel(this.token, seccion).subscribe(
      response => {
        console.log("response", response);
        const blob = new Blob([response], { type: 'application/octet-stream' });
        saveAs(blob, 'reporte_evaluacion.xlsx');
        Swal.close()
      },
      error => {
        Swal.close()
      }
    )

  }
  
  reportePDF(seccion, data){
    Swal.fire({
      title: 'Cargando datos',
      onBeforeOpen () {
        Swal.showLoading ()
      },
      onAfterClose () {
        Swal.hideLoading()
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton:false
    })
    this.crud.exportPDF(this.token, seccion, data).subscribe(
      response => {
        console.log("response", response);
        const blob = new Blob([response], { type: 'application/pdf' });
        saveAs(blob, 'reporte_'+seccion+'.pdf');
        Swal.close()
      },
      error => {
        Swal.fire('¡Oops!',error.error);
        Swal.close()
      }
    )

  }

  reporte(url){
    Swal.fire({
      title: 'Generando reporte',
      onBeforeOpen () {
        Swal.showLoading ()
      },
      onAfterClose () {
        Swal.hideLoading()
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton:false
    })
    this.crud.getFile(url, this.token, {}).subscribe(
      response => {  
        let blob = new Blob([response], { type: 'application/pdf'});
        let fileURL = window.URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
        Swal.close()
        
      },
      error => {
        console.log("error", error);
        Swal.close()
        Swal.fire('Ocurrio un error')

      }
    )
  }

}
